import _ from 'lodash';
import { ServiceManager } from '@jutro/services';

function Address(data) {
    const localeService = ServiceManager.getService('locale-service');
    this.country = localeService.getDefaultCountryCode();
    this.addressLine1 = null;
    this.addressLine2 = null;
    this.addressLine3 = null;
    this.city = null;
    this.county = null;
    this.postalCode = null;
    this.addressType = 'home';
    this.geoLatitude_Ext = null;
    this.geoLongitude_Ext = null;
    this.isLossLocation_Ext = false;
    this.isNonSpecificLocation = false;

    if (data) {
        _.extend(this, data);
    }
}

export default Address;
